import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  SalesReturnService,
  ComboService
} from "../../../services/index";

@Component({
  selector: "addEdit-SalesReturn-Bundle",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./addEditSalesReturnBundle.html",
})
export class addEditSalesReturnBundle {
  mode : string;
  saveEvent: any;
  isLoading: boolean = false;
  partyList = [];

  returndata: any = {
    ref_no: 0,
    date: new Date(),
    ret_date : null,
    party_name: null,
    total_pcs: 0,
    reason: null,

  };

  @Input() _params: any;
  @Input() active = false;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
  
    if (this.mode == "View") {
      // this.loaddesignList(this.returndata.creditid);
      this.returndata = designdata;
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesReturnService,
    private comboservice: ComboService,

  ) {}
  ngOnInit() {
    this.getPartyList();
    this.getSalesReturnBundle()
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#ret_date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else  {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);

    }
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  selectParty(party_name) {
    let that = this;
    that.partyList.forEach(function (key) {
      if (key.name == party_name) {
        that.returndata.party_id = key.genLedid;
        that.returndata.agentid = key.agent_id;
        that.returndata.transport = key.transport;

        return false;
      }
    });
    // this.returndata.party_id = $event.genLedid;
    // this.returndata.agentid = $event.agent_id;
  }
  // loaddesignList(id) {
  //   let params = {
  //     creditid: id,
  //     order_type: "Order Form",
  //     page: 1,
  //     start: 0,
  //     limit: 100,
  //   };
  //   this.salesservice.getSiRtnEntryGridShirtSizeDet(params).then((res: any) => {
  //     this.returndata = res;

  //   });
  // }


  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getSalesReturnBundle() {
  
        if (this.mode == "Add") {
          this.salesservice.getSalesReturnBundle({}).then((res: any) => {
            this.returndata.ref_no = res;
            // this.getWoAuto();
          });
        
      }
    
  }


  oncheckemptyrow() {
    let design = this.returndata;
    let empty_check = false;
    for(var key in design) {
      if(!design[key]) {
        swal("PLEASE ENTER ALL THE DETAILS!");
        empty_check = true;
        console.log(design[key])
      }
    
    }
    if(!empty_check){
    this.onSaveOrder();
    }
  }
   
   

  onSaveOrder() {
    let params: any = Object.assign({}, this.returndata);
    params["date"] = this.datePipe.transform(
      this.returndata.date,
      "yyyy-MM-dd"
    );
    params["ret_date"] = this.datePipe.transform(
      this.returndata.ret_date,
      "yyyy-MM-dd"
    );
      let that = this;
      that.isLoading = true;
      if (that.mode == "Add") {
        swal({
          title: "Are you sure to save this Return Bundle Details?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, save it!",
          cancelButtonText: "No, want to change",
        }).then(function () {
          that.isLoading = true;
          that.salesservice
            .addSalesBundleRtn(params)
            .then(function (res: any) {
              that.isLoading = false;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              if (res.success) {
                //    that.printdata(res.printData);
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              } else {
                swal("ERROR", res.message, "error");
              }
            })
            .catch(function (error: any) {
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        });
      } 
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesReturn/addEditSalesReturnBundle.ts